import { useState, useEffect } from 'react';
import '../pages/Pages.css';
import './HomePreview.css';
import staticPosts from '../data/posts';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Home page preview — latest 3 blog posts, links to full Blog page
export default function BlogPreview() {
  const [posts, setPosts] = useState(staticPosts);

  useEffect(() => {
    fetch(`${API_BASE}/api/blog`)
      .then(r => r.json())
      .then(data => {
        const normalized = data.map(p => ({
          ...p,
          img: p.img.startsWith('/uploads/') ? `${API_BASE}${p.img}` : p.img
        }));
        if (normalized.length) setPosts(normalized);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="blog-preview" className="blog-section bp-section">
      <div className="bp-header reveal">
        <span className="section-label">Latest Insights</span>
        <h2 className="section-title">From Our <em>Blog</em></h2>
        <p className="section-sub">Stay updated with the latest trends, tips, and strategies in digital marketing and web development.</p>
      </div>
      <div className="blog-grid">
        {posts.slice(0, 3).map(p => (
          <article key={p.id || p.title} className="blog-card reveal">
            <div className="blog-img">
              <img src={p.img} alt={p.title} loading="lazy" />
            </div>
            <div className="blog-body">
              <div className="blog-meta">
                <span className="blog-meta-item">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  {p.date}
                </span>
              </div>
              <span className="blog-cat">{p.cat}</span>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
              <a href={`#/blog/${p.id}`} className="blog-read">Read More →</a>
            </div>
          </article>
        ))}
      </div>
      <div className="home-more reveal">
        <a href="#/blog" className="btn-ghost">View All Posts →</a>
      </div>
    </section>
  );
}
